<template>
  <div class="MultiForm">
    <div v-for="(item, index) in items" :key="index" class="subForm">
      <slot :index="index" :item="item" />
      <Btn class="remove ib sm danger light" @click="remove(index)">
        <Icon name="cross" />
      </Btn>
    </div>
    <Empty :for="items">
      {{ $t('empty') }}
    </Empty>
    <div class="buttons">
      <Btn class="ib sm light" @click="$emit('add')">
        {{ $t('add') }}
      </Btn>
      <slot name="buttons" />
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
import { removeIndex } from '@utils/collections'

export default {
  props: {
    items: Array,
  },
  methods: {
    remove(index) {
      this.$up('items', removeIndex(index, this.items))
    },
  },
}
</script>

<style lang="scss">
.MultiForm {
  .subForm {
    @include trans(0.4s, 'background');
    border-bottom: 1px solid $border-color;
    padding: $u;
    position: relative;

    > .Btn.remove {
      position: absolute;
      right: $uh;
      top: $uh;
    }

    &:hover {
      background: $grey-lightest;
    }

    &:last-of-type {
      border-bottom: 0;
    }
  }

  > .buttons {
    margin-top: $uh;

    > .Btn {
      margin-right: $uh;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "add": "Add",
    "empty": "No items"
  }
}
</i18n>
